import React from 'react';
import { FDAlert } from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const Message = ({ label, value }) => {
  if (!value || value.length === 0) {
    return null;
  }

  return (
    <FDAlert title={label} description={value} status={'info'} />
  );
};

Message.defaultProps = {
};

Message.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
